bela<template>
  <v-data-table
    :headers="headers"
    :items="acordos"
    item-key="id"
    class="tabela paginacao-esquerda flex-table"
    fixed-header
    :items-per-page="5"
    :footer-props="{
      'items-per-page-options': [5, 10, 25, 50, 100, -1],
      itemsPerPageText: 'Linhas por páginas',
      ofText: 'de',
      pageText: '{0}-{1} de {2}',
    }"
    style="height: 420px;"
  >
    <template v-slot:[`item.actions`]="{ item }">
      <v-menu offset-y min-width="180" content-class="acordo-menu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark color="#f2f2f2" v-bind="attrs" v-on="on" small class="px-1" style="min-width: unset">
            <v-icon color="#CCC">mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list dense nav>
            <v-list-item link @click="$emit('editar', item)">
              <v-list-item-icon><v-icon color="grey lighten-1">mdi-pencil</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>Editar</v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item link @click="$emit('exibir', item)">
              <v-list-item-icon><v-icon color="grey lighten-1">mdi-file-document-edit</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>Exibir</v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="!travaInventario && (item.termino == item.mes_acordo &&
                item.termino >= mesAnterior &&
                statusAcesso(item.id_status, 'renovar') &&
                ['rd', 'cubo'].includes(usuarioTipo) &&
                !apenasLeitura(item.id_espaco))"
              link
              @click="$emit('renovar', item)"
            >
              <v-list-item-icon><v-icon color="grey lighten-1">mdi-update</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>Renovar</v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="!travaInventario &&
                statusAcesso(item.id_status, 'replicar') &&
                ['rd', 'cubo'].includes(usuarioTipo) &&
                !apenasLeitura(item.id_espaco)"
              link
              @click="$emit('replicar', item)"
            >
              <v-list-item-icon><v-icon color="primary">mdi-autorenew</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>Replicar</v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="!travaInventario &&
                statusAcesso(item.id_status, 'cancelar') &&
                ['rd', 'cubo'].includes(usuarioTipo) &&
                !apenasLeitura(item.id_espaco) &&
                !item.possui_acordo_negociacao_comercial"
              link
              @click="$emit('cancelar', item)"
            >
              <v-list-item-icon><v-icon color="grey lighten-1">mdi-cancel</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>Cancelar</v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="!travaInventario &&
                statusAcesso(item.id_status, 'liberar') &&
                ['rd', 'cubo'].includes(usuarioTipo) &&
                !apenasLeitura(item.id_espaco) &&
                !item.possui_acordo_negociacao_comercial"
              link
              @click="$emit('liberar', item)"
            >
              <v-list-item-icon><v-icon color="grey lighten-1">mdi-check</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>Liberar</v-list-item-title></v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'TabelaCircuito',
  props: {
    acordos: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    status: {
      type: Array,
      default: () => []
    },
    usuarioTipo: {
      type: String,
      default: 'rd'
    },
    travaInventario: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mesAtual() {
      return this.$moment ? this.$moment().format('YYYY-MM') : ''
    },
    mesAnterior() {
      return this.$moment ? this.$moment().subtract(1, 'months').format('YYYY-MM') : ''
    }
  },
  methods: {
    statusAcesso(id_status, acesso) {
      if (this.status) {
        const status = this.status.find((e) => e.id_status == id_status)
        return status && status[acesso]
      }
      return false
    },
    apenasLeitura(id_espaco) {
      // Acesso RD não tem restrição de leitura (mesma regra do PDV)
      if (this.usuarioTipo == 'rd') return false
      return false
    }
  }
}
</script>

<style scoped>
.tabela {
  background: #fff;
  border-radius: 15px 15px 0 0;
  box-shadow: 0 2px 8px #0001;
}
.flex-table {
  display: flex;
  flex-direction: column;
  height: 420px;
  width: 100%;
}
</style>
